/**
 * Video window
 */

export default {
  schedule_tour: "Schedule a Tour",
  infotip:
    "Simply speak to the Digital Human to get the conversation started. You can also click/tap or type, the choice is yours!",
  chat_placeholder: "Ask a question...",
};